<template>
  <div class='app-container'>
    <icare-table
      ref='table'
      :title-config='titleConfig'
      :request-fun='requestFun'
      :table-pagination='true'
      :pagination-config='tableParams'
      methods-data='get_fire_alarm'
      params>
      <div>
          <span class='left-table'>
          急停按钮：
          <el-select v-model='current_alarm' placeholder='请选择'>
            <el-option
              v-for='item in statusList'
              :key='item.value'
              :label='item.label'
              :value='item.value'
            ></el-option>
          </el-select>
        </span>
        <span class='left-table'>创建时间范围：</span>
        <el-date-picker
          v-model='findDateTime'
          type='datetimerange'
          align='right'
          start-placeholder='开始'
          end-placeholder='结止'
          format='yyyy-MM-dd HH:mm:ss'
          value-format='yyyy-MM-dd HH:mm:ss'
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
        <span class='left-table'>
          <el-button type='primary' icon='el-icon-search' @click='find'>查找</el-button>
        </span>

      </div>

    </icare-table>

  </div>
</template>

<script>
import { gateway } from '@/api/admin.js'

export default {
  data() {
    return {
      loading: false,
      tableParams: {
        start_time: '',
        end_time: '',
        current_alarm: null
      },
      current_alarm: null,
      findDateTime: [],
      statusList: [
        {
          value: 0,
          label: '全部'
        },
        {
          value: 1,
          label: '未按'
        }

      ],
      titleConfig: [
        {
          field: 'id',
          title: '流水号',
          visible: false
        },
        {
          field: 'station_name',
          title: '站点名称',
          visible: true
        },
        {
          field: 'cabinet_id',
          title: '机柜编号',
          visible: true
        },
        {
          field: 'cabinet_name',
          title: '机柜自定义编号',
          visible: true
        },
        {
          field: 'box_id',
          title: '设备类型',
          visible: true,
          fuc: val => {
            var str = (val >> 4) <= 3 ? '充电仓位' : '充电插座'
            return str
          }
        },
        {
          field: 'box_id',
          title: '充电桩号',
          visible: true,
          fuc: val => {
            var str = (val >> 4) <= 3 ? (val >> 4) + '号主站端口' : ((val >> 4) - 3) + '号主站端口-' + (val & 0xF) + '号充电桩'
            return str
          }
        },
        {
          field: 'bi',
          title: '水箱水位',
          visible: true,
          fuc: val => {
            if ((val & 0x1000) > 0) {
              return '<div style="color:#F56C6C">较低</div>'
            } else if ((val & 0x2000) > 0) {
              return '<div style="color:#F56C6C">低水位</div>'
            } else if ((val & 0x4000) > 0) {
              return '<div style="color:#F56C6C">高水位</div>'
            } else {
              return '<div style="color:#67C23A">正常</div>'
            }
          }
        },
        {
          field: 'bo',
          title: '水泵状态',
          visible: true,
          fuc: val => {
            if ((val & 0x0002) > 0) {
              return '<div style="color:#F56C6C">开启</div>'
            } else {
              return '<div style="color:#67C23A">正常</div>'
            }
          }
        },
        {
          field: 'btn',
          title: '急停按钮',
          visible: true,
          fuc: val => {
            switch (val) {
              case 'PRESSED':
                return '<div style="color:#67C23A">已按</div>'
              case 'NOT_PRESS':
                return '<div style="color:#F56C6C">未按</div>'
            }
          }
        },
        {
          field: 'user_phone',
          title: '使用用户',
          visible: true
        },
        {
          field: 'box_t2',
          title: '仓内温度',
          visible: true,
          fuc: val => {
            return val == null ? '-' : (val / 100).toFixed(2)
          }
        },
        {
          field: 'created_at',
          title: '创建时间',
          visible: true
        },
        {
          title: '操作',
          width: 60,
          align: 'right',
          option: true,
          children: [
            {
              title: '标识处理',
              color: '#F56C6C',
              icon: 'el-icon-edit-outline',
              fuc: this.clearFireAlarm
            }
          ]
        }
      ],
      form: {
        id: ''
      },
      formLabelWidth: '100px',
      editVisible: false,
      dialogType: 0
    }
  },
  computed: {
    requestFun() {
      return gateway
    }
  },
  created() {

  },
  methods: {

    //弹出编辑(新增)对话框
    showEdit(row) {
      this.dialogType = 2
      this.editVisible = true
      this.form = Object.assign({}, row)
    },
    //关闭编辑对话框
    closeDialog() {
      this.editVisible = false
      this.dialogType = 0
      this.form = {}
    },
    //模糊搜索
    find() {

      if (this.findDateTime != null && this.findDateTime.length === 2) {
        this.tableParams.start_time = this.findDateTime[0]
        this.tableParams.end_time = this.findDateTime[1]
      } else {
        this.tableParams.start_time = ''
        this.tableParams.end_time = ''
      }
      this.tableParams.current_alarm = this.current_alarm
      this.$refs.table.refresh()
    },
    //删除某条记录
    delete(row) {
      this.$confirm('是否要删除：' + row.work_group_name + '？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let str = JSON.stringify({
          id: row.id
        })
        gateway({
          func: 'del_workgroup',
          params: str
        }).then(() => {
          this.$refs.table.refresh()
        })
      }).catch(() => {
      })
    },

    save() {
      let func = ''
      if (this.dialogType === 2) {
        func = ''
      }
      let str = JSON.stringify(this.form)
      gateway({
        func: func,
        params: str
      }).then(() => {
        this.closeDialog()
        this.$refs.table.refresh()
      })
    },

    clearFireAlarm(row) {
      this.$confirm('此操作将关闭消防报警， 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {

        let str = JSON.stringify({
          cabinet_id: row.cabinet_id
        })

        gateway({
          func: 'set_clear_fire_alarm',
          params: str
        }).then((res) => {
          if (res.code == 0) {
            this.$message.success('操作成功')
            this.$refs.table.refresh()
          } else {
           this.$message.error('操作失败：'+res.msg)
          }
        })
      }).catch(() => {

      })
    }


  }
}
</script>
<style scoped>
.left-table {
  margin-right: 0.5rem;
  color: #8f9398;
  font-size: 18px;
  font-weight: 500;
  margin-left: 10px;
}

</style>
